import { GET_DEEP_LINK } from 'store/deepLink/actionTypes';
import { selectDeepLink } from 'store/deepLink/selectors';
import { createProcessingSelector } from 'store/loading/selectors';

import { DOWNLOAD_APP_EVENT_LABELS } from 'constants/analytics';

import { useSelector } from 'hooks';

import Skeleton from 'components/Skeleton';

import apple_store from './assets/app_store.webp';
import g_store from './assets/g_store.webp';
import { StoreButtonProps } from './types';

import * as S from './styled';

const StoreButton = ({ isIos, customLink, handleLinkDownloadApp }: StoreButtonProps) => {
    const isLoading: boolean = useSelector(createProcessingSelector([GET_DEEP_LINK]));
    const deepLinkUrl = useSelector(selectDeepLink);
    const eventLabel = isIos ? DOWNLOAD_APP_EVENT_LABELS.ios_bot : DOWNLOAD_APP_EVENT_LABELS.android_bot;

    return (
        <>
            {isLoading ? (
                <Skeleton height={60} borderRadius={12} />
            ) : (
                <S.StoreBtn
                    href={customLink || deepLinkUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    data-locator={isIos ? 'appleStoreLink' : 'googleStoreLink'}
                    onClick={() => handleLinkDownloadApp(eventLabel)}
                >
                    {isIos ? (
                        <S.AppleStoreImg src={apple_store} alt="App store button" />
                    ) : (
                        <S.GooglePlayMarketImg src={g_store} alt="Google play market button" />
                    )}
                </S.StoreBtn>
            )}
        </>
    );
};

export default StoreButton;
